import { create } from 'zustand'
import { reportError } from '@/app/utils/functions'
import liff from '@line/liff'

type LiffTokenStore = {
    token: string
    getToken: () => void
}

const useLiffToken = create<LiffTokenStore>((set, get) => ({
    token: null,
    getToken: () => {
        const liffId = process.env.SITE_LIFF_ID
        liff.init({liffId: liffId})
        .then(() => {
            set({token: liff.getAccessToken()})

            // // for test
            // set({
            //     token: 'eyJhbGciOiJIUzI1NiJ9.Rh2ot5-dNSNNNDYCmiZO21V7Hms4IKTlxWnRcp-ag4J-iQRegP2RVPp1CyuFlN0d5p69psrKDv-IE92U_lWyS6DPKzqpE65KrwkO-FaUjNfDFnWPvI4iA4qpqTimjV1kJA9wpPE3QVXlx5SxFn2nWCM3586jV9VPYzh_2uwG1lE.voMYXrdU7-2gpGq4eebhZSu_uYXaYHzjb78HarEND4Q'
            // })
        })
        .catch((err) => {
            // console.log('liff init fail: ', err)
            reportError(err, true)
        })
    }
}))

export default useLiffToken
